import Play from './icons/play.svg'
import Pause from './icons/pause.svg'
import Replay from './icons/replay.svg'
import VolumeHigh from './icons/volume-high.svg'
import VolumeLow from './icons/volume-low.svg'
import VolumeMute from './icons/volume-mute.svg'
import Warning from './icons/warning.svg'

export default {
  Play,
  Pause,
  Replay,
  VolumeHigh,
  VolumeLow,
  VolumeMute,
  Warning
}
